module.exports = __webpack_public_path__ + "img/Sign_367.c2375934.png";